export async function logout(): Promise<void> {
  await fetch('/api/auth/logout', { method: 'POST', credentials: 'include' })
  window.location.href = '/login'
}

export async function apiPost<T>(url: string, body: unknown): Promise<{ data?: T; error?: string }> {
  const res = await fetch(url, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const json = await res.json()
  if (!res.ok || json.success === false) return { error: json.error ?? 'Erreur' }
  return { data: json.data ?? json }
}

export async function apiPut<T>(url: string, body: unknown): Promise<{ data?: T; error?: string }> {
  const res = await fetch(url, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const json = await res.json()
  if (!res.ok || json.success === false) return { error: json.error ?? 'Erreur' }
  return { data: json.data ?? json }
}

export async function apiPatch<T>(url: string, body: unknown): Promise<{ data?: T; error?: string }> {
  const res = await fetch(url, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
  const json = await res.json()
  if (!res.ok || json.success === false) return { error: json.error ?? 'Erreur' }
  return { data: json.data ?? json }
}

export async function apiDelete(url: string): Promise<{ error?: string }> {
  const res = await fetch(url, { method: 'DELETE', credentials: 'include' })
  const json = await res.json()
  if (!res.ok) return { error: json.error ?? 'Erreur' }
  return {}
}
